module.exports = __webpack_public_path__ + "img/cup-1.bc99be84.png";